var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Sidebar from 'components/shared/sidebar/component';
import Infobox from 'components/player/shared/infobox/component';
import Modal from 'components/player/shared/modal/component';
import TaskModalContent from '../../../../player/task/modal-content/component';
import { taskRequestNew, taskRequestUpdate } from '../../../../../socketConnection/socketMessageRequests/taskRequests';
import { SIDEBAR_MODE_PLAYER, WEBSOCKET_MESSAGE } from 'components/constants';
import { TASK_TYPE_COMPANY, TASK_TYPE_PLAYER } from 'components/player/task/constants';
import { setT } from 'helpers/translationUtilities';
export default function ViewNewTask() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var presetTasks = useSelector(function (state) { return state.player.tasks.items; });
    var game = useSelector(function (state) { return state.game; });
    var presetPlayer = useSelector(function (state) { return state.player; });
    var _a = useState(presetTasks), tasks = _a[0], setTasks = _a[1];
    var _b = useState(presetPlayer), player = _b[0], setPlayer = _b[1];
    var _c = useState(null), expanded = _c[0], setExpanded = _c[1];
    var _d = useState(null), activeTaskID = _d[0], setActiveTaskID = _d[1];
    var _e = useState('Player'), taskType = _e[0], setTaskType = _e[1];
    useEffect(function () {
        if (player.id !== presetPlayer.id || player.company.id !== presetPlayer.company.id) {
            setTasks(presetTasks);
            setPlayer(presetPlayer);
            return;
        }
        if (presetTasks && presetTasks.length > tasks.length) {
            var foundNewTask = presetTasks.find(function (nextTask) {
                var found = tasks.find(function (t) { return t.id === nextTask.id; });
                return !found && (nextTask.to === player.id || nextTask.to === player.company.id);
            });
            var type = foundNewTask && foundNewTask.to !== player.id ? 'Company' : 'Player';
            setTasks(presetTasks);
            setActiveTaskID(foundNewTask ? foundNewTask.id : null);
            setTaskType(type);
            if (foundNewTask)
                setExpanded('taskModal');
        }
    }, [presetTasks, presetPlayer]);
    function requestNewTask(type) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = dispatch;
                        _b = { type: WEBSOCKET_MESSAGE };
                        return [4 /*yield*/, taskRequestNew({ type: type })];
                    case 1:
                        _a.apply(void 0, [(_b.payload = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    }
    function taskUpdate(id, type, status) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = dispatch;
                        _b = { type: WEBSOCKET_MESSAGE };
                        return [4 /*yield*/, taskRequestUpdate(id, type, status)];
                    case 1:
                        _a.apply(void 0, [(_b.payload = _c.sent(), _b)]);
                        setExpanded(false);
                        navigate('/task');
                        return [2 /*return*/];
                }
            });
        });
    }
    var taskSettings = game.taskSettings;
    var options = [
        {
            name: setT('personal_task'),
            description: setT('new_personal_task_text'),
            disabled: !taskSettings.playerCards,
            type: TASK_TYPE_PLAYER
        },
        {
            name: setT('business_task'),
            description: setT('new_business_task_text'),
            disabled: !taskSettings.companyCards,
            type: TASK_TYPE_COMPANY
        }
    ];
    var task = (tasks || []).find(function (t) { return t.id === activeTaskID; });
    return (React.createElement("div", { className: "playerdashboard playerdashboard--with-players-sidebar" },
        React.createElement(Sidebar, { type: SIDEBAR_MODE_PLAYER }),
        React.createElement(Infobox, { title: setT('choose_your_task') },
            React.createElement("div", { className: "task-group" },
                React.createElement("div", { className: "task-group__list f-grid flex-wrap flex-no-wrap-md" }, options.map(function (option, index) { return (React.createElement("div", { key: index, className: clsx(['task-group__item f-grid-col-12 f-grid-col-md-6', option.disabled && 'task-group__item--disabled']), onClick: option.disabled ? null : function () { return requestNewTask(option.type); } },
                    React.createElement("div", { className: "task-group-item__inner" },
                        React.createElement("div", { className: 'task-group-item__icon icon icon--img icon--task_' + (option.type === 1 ? 'personal' : 'company') }),
                        React.createElement("div", { className: "task-group-item__details text-align-center" },
                            React.createElement("div", { className: "task-group-item__name" }, option.name),
                            React.createElement("div", { className: "task-group-item__description" }, option.description)),
                        React.createElement("div", { className: "icon icon--check icon--fill-grey" })))); })))),
        React.createElement(Modal, { mobileFullScreen: true, expanded: expanded === 'taskModal', onClose: function () { return setExpanded(false); } }, task && (React.createElement(TaskModalContent, { action: 'confirm', redirectToTasks: function () { return navigate('/task'); }, icon: taskType === 'Player' ? 'task_personal' : 'task_company', isPlayerTask: taskType === 'Player', fields: task, onUpdate: function (id, type, status) { return taskUpdate(id, type, status); }, closeModal: function () { return setExpanded(false); } })))));
}
